import React, { useRef } from "react";
import { getClassName } from "@sscs/utils";
import { useIsOverflowing } from "../../hooks";
import styles from "./longTextLabel.module.scss";
function LongTextLabel({ label, title, className, maxCharacters, inline = false, }) {
    const ref = useRef(null);
    const isOverMaxCharacters = maxCharacters && typeof label === "string" && label.length > maxCharacters;
    const isOverflowing = useIsOverflowing(ref) || isOverMaxCharacters;
    const titleString = title ? title : label;
    return (React.createElement("span", { ref: ref, title: isOverflowing && typeof titleString === "string"
            ? titleString
            : undefined, className: getClassName(styles.root, className, {
            [styles.inline]: inline,
        }) }, isOverMaxCharacters ? label.slice(0, maxCharacters - 2) + "..." : label));
}
export default LongTextLabel;
//# sourceMappingURL=LongTextLabel.js.map